// CardInfo.jsx
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Type, List } from "react-feather";
import Modal from "../../Modal/Modal";
import Editable from "../../Editabled/Editable";
import { updateCard } from "../../../../Redux/Reducers/CrmSlice";
import "./CardInfo.css";

function CardInfo({ card, stageId,  onClose ,updateCard}) {
  const [values, setValues] = useState({ ...card });
  

  const updateTitle = (value) => {
    setValues({ ...values, name: value }); 
    
  };

  const updatePartnerName = (value) => {
    setValues({ ...values, partner_id: value }); 
  };

  const updateExpectedRevenue = (value) => {
    setValues({ ...values, expected_revenue: value }); 
  };

  useEffect(() => {
    // Update Redux state when component unmounts or values change
    return () => {
      if (updateCard) {
        updateCard(stageId, values.id, values);
      }
    };
  }, [stageId, updateCard, values]);

  return (
    <Modal onClose={onClose}>
      <div className="cardinfo">
        <div className="cardinfo_box">
          <div className="cardinfo_box_title">
            <Type />
            <p>Title</p>
          </div>
          <Editable
            defaultValue={values.name}
            text={values.name || "Add a Name"}
            placeholder="Enter Title"
            onSubmit={updateTitle}
          />
        </div>

        <div className="cardinfo_box">
          <div className="cardinfo_box_title">
            <List />
            <p>Partner Name</p>
          </div>
          <Editable
            defaultValue={values.partner_id}
            text={values.partner_id?.[1] || "Add Partner Name"}
            placeholder="Enter Partner Name"
            onSubmit={updatePartnerName}
          />
        </div>

        <div className="cardinfo_box">
          <div className="cardinfo_box_title">
            <List />
            <p>Expected Revenue</p>
          </div>
          <Editable
            defaultValue={values.expected_revenue}
            text={values.expected_revenue || "Add Expected Revenue"}
            placeholder="Enter Expected Revenue"
            onSubmit={updateExpectedRevenue}
          />
        </div>
      </div>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateCard: (stageId, cardId, updatedCard) =>
      dispatch(updateCard({ stageId, cardId, updatedCard })),
  };
};

export default connect(null, mapDispatchToProps)(CardInfo);
